import CouponPreview from '~/components/builder/CouponPreview/CouponPreview';
import VideoPreview from '~/components/builder/VideoPreview/VideoPreview';
import { AppsPreviewScreen } from '~/components/organisms/previewBar/components/apps/AppsPreviewScreen';
import { ImagesPreviewScreen } from '~/components/organisms/previewBar/components/images/ImagesPreviewScreen';
import { LIST_OF_LINKS_TEMPLATE_0 } from '~/components/organisms/previewBar/components/list-of-links/components/LIST_OF_LINKS_TEMPLATE_0';
import { LIST_OF_LINKS_TEMPLATE_1 } from '~/components/organisms/previewBar/components/list-of-links/components/LIST_OF_LINKS_TEMPLATE_1';
import { LIST_OF_LINKS_TEMPLATE_2 } from '~/components/organisms/previewBar/components/list-of-links/components/LIST_OF_LINKS_TEMPLATE_2';
import { LIST_OF_LINKS_TEMPLATE_3 } from '~/components/organisms/previewBar/components/list-of-links/components/LIST_OF_LINKS_TEMPLATE_3';
import { LIST_OF_LINKS_TEMPLATE_4 } from '~/components/organisms/previewBar/components/list-of-links/components/LIST_OF_LINKS_TEMPLATE_4';
import { LIST_OF_LINKS_TEMPLATE_5 } from '~/components/organisms/previewBar/components/list-of-links/components/LIST_OF_LINKS_TEMPLATE_5';
import { LIST_OF_LINKS_TEMPLATE_6 } from '~/components/organisms/previewBar/components/list-of-links/components/LIST_OF_LINKS_TEMPLATE_6';
import { LIST_OF_LINKS_TEMPLATE_7 } from '~/components/organisms/previewBar/components/list-of-links/components/LIST_OF_LINKS_TEMPLATE_7';
import { LIST_OF_LINKS_TEMPLATE_8 } from '~/components/organisms/previewBar/components/list-of-links/components/LIST_OF_LINKS_TEMPLATE_8';
import { PDF_TEMPLATE_0 } from '~/components/organisms/previewBar/components/pdf/components/PDF_TEMPLATE_0';
import { PDF_TEMPLATE_1 } from '~/components/organisms/previewBar/components/pdf/components/PDF_TEMPLATE_1';
import { PDF_TEMPLATE_2 } from '~/components/organisms/previewBar/components/pdf/components/PDF_TEMPLATE_2';
import { PDF_TEMPLATE_3 } from '~/components/organisms/previewBar/components/pdf/components/PDF_TEMPLATE_3';
import { PDF_TEMPLATE_4 } from '~/components/organisms/previewBar/components/pdf/components/PDF_TEMPLATE_4';
import { SocialMediaPreviewScreen } from '~/components/organisms/previewBar/components/social-media/SocialMediaPreviewScreen';
import { VCARD_PLUS_TEMPLATE_0 } from '~/components/organisms/previewBar/components/vcard-plus/components/VCARD_PLUS_TEMPLATE_0';
import { VCARD_PLUS_TEMPLATE_1 } from '~/components/organisms/previewBar/components/vcard-plus/components/VCARD_PLUS_TEMPLATE_1';
import { VCARD_PLUS_TEMPLATE_2 } from '~/components/organisms/previewBar/components/vcard-plus/components/VCARD_PLUS_TEMPLATE_2';
import VCARD_PLUS_TEMPLATE_3 from '~/components/organisms/previewBar/components/vcard-plus/components/VCARD_PLUS_TEMPLATE_3';
import { VCARD_PLUS_TEMPLATE_4 } from '~/components/organisms/previewBar/components/vcard-plus/components/VCARD_PLUS_TEMPLATE_4';
import { VCARD_PLUS_TEMPLATE_5 } from '~/components/organisms/previewBar/components/vcard-plus/components/VCARD_PLUS_TEMPLATE_5';

export const micrositeTypeComponent = {
  links: (templateId) => {
    switch (templateId) {
      case 0:
        return <LIST_OF_LINKS_TEMPLATE_0 isMyMicrosite />;
      case 1:
        return <LIST_OF_LINKS_TEMPLATE_1 isMyMicrosite />;
      case 2:
        return <LIST_OF_LINKS_TEMPLATE_2 isMyMicrosite />;
      case 3:
        return <LIST_OF_LINKS_TEMPLATE_3 isMyMicrosite />;
      case 4:
        return <LIST_OF_LINKS_TEMPLATE_4 isMyMicrosite />;
      case 5:
        return <LIST_OF_LINKS_TEMPLATE_5 isMyMicrosite />;
      case 6:
        return <LIST_OF_LINKS_TEMPLATE_6 isMyMicrosite />;
      case 7:
        return <LIST_OF_LINKS_TEMPLATE_7 isMyMicrosite />;
      case 8:
        return <LIST_OF_LINKS_TEMPLATE_8 isMyMicrosite />;
      default:
        return null;
    }
  },
  images: () => {
    return <ImagesPreviewScreen stopNetworkLoading isMyMicrosite />;
  },
  app: () => {
    return <AppsPreviewScreen isMyMicrosite />;
  },
  pdf: (templateId) => {
    switch (templateId) {
      case 0:
        return <PDF_TEMPLATE_0 isMyMicrosite />;
      case 1:
        return <PDF_TEMPLATE_1 isMyMicrosite />;
      case 2:
        return <PDF_TEMPLATE_2 isMyMicrosite />;
      case 3:
        return <PDF_TEMPLATE_3 isMyMicrosite />;
      case 4:
        return <PDF_TEMPLATE_4 isMyMicrosite />;
      default:
        return null;
    }
  },
  ['social-media']: () => {
    return <SocialMediaPreviewScreen isMyMicrosite />;
  },
  ['vcard-plus']: (templateId) => {
    switch (templateId) {
      case 0:
        return <VCARD_PLUS_TEMPLATE_0 isMyMicrosite />;
      case 1:
        return <VCARD_PLUS_TEMPLATE_1 isMyMicrosite />;
      case 2:
        return <VCARD_PLUS_TEMPLATE_2 isMyMicrosite />;
      case 3:
        return <VCARD_PLUS_TEMPLATE_3 isMyMicrosite />;
      case 4:
        return <VCARD_PLUS_TEMPLATE_4 isMyMicrosite />;
      case 5:
        return <VCARD_PLUS_TEMPLATE_5 isMyMicrosite />;
      default:
        return null;
    }
  },
  coupon: (_, couponQrData) => {
    return <CouponPreview isMyMicrosite couponQrData={couponQrData} />;
  },
  video: (_, videoQrData) => {
    return <VideoPreview isMyMicrosite videoQrData={videoQrData} />;
  },
};
